import {
  model,
  Model,
  modelAction,
  prop,
  Frozen,
  rootRef,
  modelFlow,
  _async,
  getRoot,
  _await,
  findParent,
  getSnapshot,
} from "mobx-keystone";
import { computed, observable } from "mobx";
import { Cubby } from "./Cubby";

@model("exrails/Blocker")
export class Blocker extends Model({
  _version: prop(0),
  uuid: prop<string>(),
  kind: prop<string>(),
  uniqueExternalIdentifier: prop<string>(),
}) {
  getRefId() {
    // when `getId` is not specified in the custom reference it will use this as id
    return this.uuid;
  }
  @computed
  get cubby() {
    return findParent<Cubby>(this, (parentNode) => parentNode instanceof Cubby);
  }
}
